import { Contexts } from "@upmind-automation/types";
import _ from "@/boot/lodash";

export default {
  computed: {
    context() {
      return this.$store.state.context;
    },
    guestAccessToken() {
      return _.get(this.$store.state, "auth.guest.token.access_token");
    },
    isMockClientContext(): boolean {
      return this.$store.getters["isMockClientContext"]();
    },
    isAdmin(): boolean {
      return !this.isMockClientContext && this.context === Contexts.ADMIN;
    },
    isClient(): boolean {
      return !!this.isMockClientContext || this.context === Contexts.CLIENT;
    },
    isGuest(): boolean {
      return this.context === Contexts.GUEST;
    }
  }
};
